"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { UserPageTabType } from "../layout/UserPageTabs";
import { getProfileTargetRoute } from "@/helpers/Helpers";
import { usePathname } from "next/navigation";
export default function CommonProfileLink(t0) {
  const $ = _c(11);
  const {
    handleOrWallet,
    isCurrentUser,
    tabTarget
  } = t0;
  const pathname = usePathname();
  const t1 = pathname ?? "";
  let t2;
  if ($[0] !== handleOrWallet || $[1] !== t1 || $[2] !== tabTarget) {
    t2 = getProfileTargetRoute({
      handleOrWallet,
      pathname: t1,
      defaultPath: tabTarget
    });
    $[0] = handleOrWallet;
    $[1] = t1;
    $[2] = tabTarget;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const url = t2;
  const t3 = `${isCurrentUser ? "tw-pointer-events-none tw-no-underline" : ""} tw-leading-4 tw-p-0`;
  const t4 = `${isCurrentUser ? "" : "tw-cursor-pointer"} tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out`;
  let t5;
  if ($[4] !== handleOrWallet || $[5] !== t4) {
    t5 = <span className={t4}>{handleOrWallet}</span>;
    $[4] = handleOrWallet;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5 || $[9] !== url) {
    t6 = <Link href={url} className={t3}>{t5}</Link>;
    $[7] = t3;
    $[8] = t5;
    $[9] = url;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}